import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Rfid } from '../../atoms/icons/rfid';
import { useSelector } from '../../store/utils';
import { useFormatNumber } from '../../utils/format-number';
import { Card, defaultKwh } from './report-card';

/**
 * Monthly report section: per-RFID-card wallbox consumption. The consumption
 * values come from the stored report payload (computed at report generation);
 * card names come from the live store.
 */
export const ReportRfidCard = ({
  consumptionByCard,
}: {
  consumptionByCard?: Record<string, number>;
}) => {
  const formatNumber = useFormatNumber();
  const rfidCards = useSelector((state) => state.variables.RFID_CARDS);

  const entries = Object.entries(rfidCards ?? {});

  if (entries.length === 0) return null;

  return (
    <Card
      title={
        <FormattedMessage id="reports.rfid_cards" defaultMessage="RFID karty" />
      }
      icon={<Rfid />}
      visibility={{ variableIds: ['WB_INSTALL', 'RFID_VISIBLE'] }}
      lines={entries.map(([id, { name }]): [ReactNode, ReactNode] => [
        name,
        formatNumber(consumptionByCard?.[id] ?? 0, defaultKwh),
      ])}
    />
  );
};
